import { createContext } from 'react';

const ProductContext: any = createContext();

export default ProductContext;
